/* eslint-disable @typescript-eslint/promise-function-async */
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const VehicleInformationRoutes = [
  {
    path: RoutePaths.NEW_QUOTATION.VEHICLE_INFORMATION.INSURANCE_SITUATION.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/vehicle-information/insurance-situation/insurance-situation.module').then(
        m => m.InsuranceSituationPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.VEHICLE_INFORMATION.VEHICLE_SELECTION_TYPE.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/vehicle-information/vehicle-selection-type/vehicle-selection-type.module').then(
        m => m.VehicleSelectionTypePageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.VEHICLE_INFORMATION.VEHICLE_SELECTION.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/vehicle-information/vehicle-selection/vehicle-selection.module').then(
        m => m.VehicleSelectionPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.VEHICLE_INFORMATION.CHOSE_YOUR_CAR.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/vehicle-information/chose-your-car/chose-your-car.module').then(m => m.ChoseYourCarPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.VEHICLE_INFORMATION.KM_PER_YEAR_SELECTION.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/vehicle-information/km-per-year-selection/km-per-year-selection.module').then(
        m => m.KmPerYearSelectionPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.VEHICLE_INFORMATION.OWNER.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/vehicle-information/owner/owner.module').then(m => m.OwnerPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.VEHICLE_INFORMATION.SEASONAL_PLATE.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/vehicle-information/seasonal-plate/seasonal-plate.module').then(m => m.SeasonalPlatePageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.VEHICLE_INFORMATION.VEHICLE_USAGE.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/vehicle-information/vehicle-usage/vehicle-usage.module').then(m => m.VehicleUsagePageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.VEHICLE_INFORMATION.PARKING_VARIANTS.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/vehicle-information/parking-variants/parking-variants.module').then(
        m => m.ParkingVariantsPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.VEHICLE_INFORMATION.FINANCING.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/vehicle-information/financing/financing.module').then(m => m.FinancingPageModule),
    canActivate: [NavigationGuard],
  },
];
